import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../Icon';
import RawHtml from '../RawHtml/RawHtml';
import styles from './Alert.module.scss';
import { ucFirst } from '../../utils/caseconverters';

const variants = {
    info: { icon: 'alertInfo', label: 'Note' },
    warning: { icon: 'alertWarning', label: 'Warning' },
    tip: { icon: 'alertTip', label: 'Tip' },
};

const Alert = ({ variant = 'info', text = '' }) => {
    const { icon, label } = variants[variant] || variants.info;

    return (
        <div
            className={classNames(
                styles['Alert'],
                styles['Alert--' + ucFirst(variant)]
            )}>
            <div className={styles['Alert__Icon']}>
                <Icon type={icon} modifiers={['Alert']} />
            </div>
            <span className="sr-only">{label}: </span>
            <div className={styles['Alert__Text']}>
                <RawHtml html={text} />
            </div>
        </div>
    );
};

Alert.propTypes = {
    variant: PropTypes.oneOf(['info', 'warning', 'tip']),
    text: PropTypes.string,
};

export default Alert;
